const host = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (":" + window.location.port) : '');

let backHost = ""
const projectPrefix = "";

if (process.env.NODE_ENV === "production") {
  // 线上环境
  backHost = "https://yuanmapay.cn/api";
} else {
  // 本地环境 测试环境
  // backHost = "http://192.168.5.3:9232/yuanmaPayBack";
  backHost = 'https://yuanmapay.cn/api'
}

const config = {
  // 当前地址
  host: host,

  // 后台地址
  backHost: backHost,

  projectPrefix: projectPrefix,

  maxLodingTime: 1000 * 60,

  // 路由名称
  projectName: "缘码支付",
  // 版权所属公司
  companyName: "缘码之家",

  signTime: 60 * 1000
}

export default config;
